import { render, staticRenderFns } from "./SchoolItem.vue?vue&type=template&id=bd508666&scoped=true"
import script from "./SchoolItem.vue?vue&type=script&lang=js"
export * from "./SchoolItem.vue?vue&type=script&lang=js"
import style0 from "./SchoolItem.vue?vue&type=style&index=0&id=bd508666&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd508666",
  null
  
)

export default component.exports